import { Container, Stack } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSettingsContext } from 'src/legacy/components/settings';

import { HEADER } from '../../config-global';
import useOffSetTop from '../../hooks/useOffSetTop';
import Header from './Header';

const CompactLayout = () => {
  const { setVisible } = useSettingsContext();
  const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);

  useEffect(() => {
    setVisible(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header isOffset={isOffset} />

      <Container component="main">
        <Stack
          sx={{
            justifyContent: 'center',
            m: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            py: 12,
            textAlign: 'center',
          }}
        >
          <Outlet />
        </Stack>
      </Container>
    </>
  );
};

export default CompactLayout;
